export function legacyFunnelEditorHref(
  funnelId: number,
  query?: URLSearchParams,
) {
  const suffix = query?.toString();
  return `/editor/${funnelId}${suffix ? `?${suffix}` : ""}`;
}

/** The legacy editor lives at /editor/<funnel id>; the revamped one under /editor/<kind>/<id>. */
export function isLegacyEditorPath(pathname: string) {
  return /^\/editor\/\d+\/?$/.test(pathname);
}

/** The storefront serves the legacy editor's preview under /preview/legacy. */
export function legacyFunnelIframeLink(funnelCode: string) {
  return `${process.env.JURNI_STOREFRONT_URL}/preview/legacy/${funnelCode}?mode=editor`;
}
